import { deleteFeeType } from "actions/Utilities/Policy";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "components/toastNotification";

const useDeleteFeeType = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((ids: string[]) => deleteFeeType(ids), {
    onSuccess: () => {
      queryClient.invalidateQueries(["GetFeeTypes"]);
      toast.fire(
        "Success",
        "Fee Types were deactivated successfully",
        "success"
      );
    },
    onError: () => {
      toast.fire(
        "Bulk deactivation of Fee Types failed",
        "Server Error: Cannot deactivate Fee Types",
        "error"
      );
    },
  });

  return mutate;
};
export default useDeleteFeeType;
